<div class="flex flex-wrap items-center gap-1.5 px-4 py-1.5">
  <ng-content select="[filter-presets]" />
  @if (folded()) {
    <span
      class="bg-accent-interactive text-accent-main inline-flex items-center gap-1.5 rounded-full py-[3px] pr-1 pl-2.5 text-xs">
      <button
        type="button"
        data-advanced-pill
        class="inline-flex cursor-pointer items-center gap-1.5 font-semibold"
        (click)="openAdvanced.emit()">
        <i [class]="ICONS.slidersHorizontal" aria-hidden="true"></i>
        {{
          (conditionCount() === 1
            ? 'features.data.path_filter.advanced_pill_one'
            : 'features.data.path_filter.advanced_pill'
          ) | translate: { count: conditionCount() }
        }}
      </button>
      <button
        type="button"
        class="hover:bg-accent-interactive-hover inline-flex size-[18px] cursor-pointer items-center justify-center rounded-full text-[10px] transition-colors"
        [attr.aria-label]="'features.data.path_filter.clear_filter' | translate"
        (click)="clear()">
        <i [class]="ICONS.x" aria-hidden="true"></i>
      </button>
    </span>
  } @else {
    @for (pill of pills(); track pill.id) {
      <span
        #pillEl
        data-pill
        class="bg-accent-interactive text-accent-main inline-flex items-center gap-1.5 rounded-full py-[3px] pr-1 pl-2.5 text-xs">
        <button
          type="button"
          class="inline-flex cursor-pointer items-center gap-1.5"
          (click)="edit(pill.id, pillEl)">
          <span data-pill-field>{{ pill.field }}</span>
          <span class="text-text-secondary">{{ pill.op }}</span>
          @if (pill.value) {
            <b class="font-mono font-semibold">{{ pill.value }}</b>
          }
        </button>
        <button
          type="button"
          class="hover:bg-accent-interactive-hover inline-flex size-[18px] cursor-pointer items-center justify-center rounded-full text-[10px] transition-colors"
          [attr.aria-label]="
            'features.data.path_filter.remove_filter_on' | translate: { field: pill.field }
          "
          (click)="remove(pill.id)">
          <i [class]="ICONS.x" aria-hidden="true"></i>
        </button>
      </span>
    }
  }

  <button
    #addButton
    type="button"
    class="border-accent-border text-accent-main hover:bg-accent-interactive inline-flex cursor-pointer items-center gap-1.5 rounded-full border px-[9px] py-[3px] text-xs font-semibold transition-colors"
    [class.border-dashed]="!menuOpen()"
    [class.bg-accent-interactive]="menuOpen()"
    [attr.aria-label]="'features.data.path_filter.add_filter_aria' | translate"
    [attr.aria-expanded]="menuOpen()"
    aria-haspopup="menu"
    (click)="menuOpen.set(!menuOpen())">
    <i [class]="ICONS.plus" aria-hidden="true"></i
    >{{ 'features.data.path_filter.add_filter' | translate }}
  </button>
  <button
    type="button"
    class="text-text-secondary hover:bg-interactive hover:text-text-primary inline-flex cursor-pointer items-center gap-1.5 rounded-xs px-1.5 py-[3px] text-xs transition-colors"
    (click)="openAdvanced.emit()">
    <i [class]="ICONS.slidersHorizontal" aria-hidden="true"></i
    >{{ 'features.data.path_filter.advanced' | translate }}
  </button>
  <ng-content select="[sort-chip]" />
  <div class="ml-auto flex items-center gap-1.5"><ng-content /></div>
</div>

<app-dropdown
  [target]="addButton"
  [template]="fieldMenu"
  [isOpen]="menuOpen()"
  [onClose]="closeMenu"
  [useDefaultStyles]="false" />
@for (edit of editingList(); track edit.id) {
  <app-dropdown
    [target]="edit.anchor"
    [template]="valuePopover"
    [isOpen]="true"
    [onClose]="closeEditor"
    [useDefaultStyles]="false" />
}

<ng-template #fieldMenu>
  <div class="g-menu w-60" role="menu" appFocusFirst>
    <div class="g-menu-search">
      <i [class]="ICONS.magnifyingGlass" aria-hidden="true"></i>
      <input
        type="text"
        [value]="fieldSearch()"
        [placeholder]="'features.data.path_filter.field_search' | translate"
        [attr.aria-label]="'features.data.path_filter.field_search' | translate"
        [attr.aria-controls]="menuId"
        [attr.aria-activedescendant]="activeOptionId()"
        (input)="onFieldSearch($any($event.target).value)"
        (keydown)="onFieldSearchKey($event)" />
    </div>
    <div class="g-menu-scroll" [id]="menuId">
      @for (option of fieldOptions(); track option.field.key; let i = $index) {
        <button
          type="button"
          role="menuitem"
          class="g-menu-item w-full"
          [id]="optionId(i)"
          [class.is-focused]="i === highlighted()"
          (click)="pickField(option.field)">
          <i [class]="option.icon" aria-hidden="true"></i>
          <span class="ellipsis flex-1 text-left">{{ option.label }}</span>
          <span class="shortcut">{{ option.hint }}</span>
        </button>
      } @empty {
        @if (associationOptions().length === 0) {
          <div class="g-menu-empty">
            {{ 'features.data.path_filter.no_fields' | translate }}
          </div>
        }
      }
      @if (associationOptions().length > 0) {
        @if (fieldOptions().length > 0) {
          <div class="g-menu-divider"></div>
        }
        <div class="g-menu-label">
          {{ 'features.data.path_filter.related_entity' | translate }}
        </div>
        @for (
          option of associationOptions();
          track option.association.edge;
          let j = $index
        ) {
          <button
            type="button"
            role="menuitem"
            class="g-menu-item w-full"
            [id]="optionId(fieldOptions().length + j)"
            [class.is-focused]="fieldOptions().length + j === highlighted()"
            (click)="pickAssociation(option.association)">
            <i [class]="ICONS.treeStructure" aria-hidden="true"></i>
            <span class="ellipsis flex-1 text-left">{{ option.label }}</span>
            <span class="shortcut">
              {{
                'features.data.path_filter.cardinality.' + option.association.cardinality
                  | translate
              }}
            </span>
          </button>
        }
      }
    </div>
  </div>
</ng-template>

<ng-template #valuePopover>
  <div class="g-menu" appFocusFirst (keydown)="onPopoverKey($event)">
    @if (editedCondition(); as condition) {
      <app-path-filter-condition
        layout="stacked"
        [condition]="condition"
        [context]="context()"
        (conditionChange)="onEdited($event)"
        (removed)="remove(condition.id)" />
    }
  </div>
</ng-template>
